module.exports = __webpack_public_path__ + "static/media/twitter-480.d2dd17d5.png";